import { PT } from '../utils/available-languages'
import {
  BANGALO_TITLE,
  CASA_TITLE,
} from '../utils/available-accommodations'

export const getMessages = (language = PT) => {
  const messages = {
    title: agendaMessages.title[language],
    weekdays: agendaMessages.weekdays[language],
    months: agendaMessages.months[language],
    previous: agendaMessages.previous[language],
    next: agendaMessages.next[language],
  }

  return messages
}

export const getAccommodationSubtitle = (accommodation, language = PT) => {
  return {
    text: agendaMessages.subtitle.text[accommodation][language],
    color: agendaMessages.subtitle.color[accommodation],
  }
}

const agendaMessages = {
  title: {
    [PT]: 'Disponibilidade',
  },
  weekdays: {
    [PT]: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  },
  months: {
    [PT]: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
  },
  previous: {
    [PT]: 'Mês anterior',
  },
  next: {
    [PT]: 'Próximo mês',
  },
  subtitle: {
    text: {
      [BANGALO_TITLE]: {
        [PT]: 'Bangalô reservado',
      },
      [CASA_TITLE]: {
        [PT]: 'Casa reservada',
      },
    },
    color: {
      [BANGALO_TITLE]: '#D45A58',
      [CASA_TITLE]: '#7A5487',
    }
  }
}
